const API = process.env.REACT_APP_API_URL || '';

function authHeaders() {
  const headers = { 'Content-Type': 'application/json' };
  try {
    const stored = JSON.parse(localStorage.getItem('fvl_auth') || 'null');
    if (stored?.credential) headers.Authorization = `Bearer ${stored.credential}`;
    else if (stored?.email) headers['x-admin-email'] = stored.email;
  } catch { /* ignore */ }
  return headers;
}

export async function getNewsletterPlan() {
  const res = await fetch(`${API}/api/internal/newsletter`, { headers: authHeaders() });
  return res.json();
}

export async function setNewsletterPlan(body) {
  const res = await fetch(`${API}/api/internal/newsletter`, {
    method: 'PUT',
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  return res.json();
}
